import React, { useMemo } from 'react';
import { CheckCircleIcon, ChartBarIcon, TargetIcon } from '../icons/InterfaceIcons';
import { calculateUserStats } from '../../utils/userStats';

const StatDisplay = ({ icon, label, value, colorClass }) => (
    <div className="flex items-center space-x-4">
        <div className={`flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-xl bg-opacity-10 ${colorClass}`}>
            {icon}
        </div>
        <div>
            <p className="text-2xl font-bold text-brand-text-primary">{value}</p>
            <p className="text-sm text-brand-text-secondary">{label}</p>
        </div>
    </div>
);


export const PerformanceGlanceCard = ({ completedTests }) => {
    const stats = useMemo(() => calculateUserStats(completedTests), [completedTests]);

    return (
        <div className="bg-brand-surface border border-brand-border rounded-xl p-6 h-full flex flex-col justify-between gap-6 shadow-card">
            <div>
                <h3 className="font-bold text-xl text-brand-text-primary">Performance At a Glance</h3>
                <p className="text-brand-text-secondary mt-1">
                    Your calculated performance based on all completed tests.
                </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                 <StatDisplay 
                    icon={<CheckCircleIcon className="w-6 h-6"/>}
                    label="Tests Taken"
                    value={stats.totalTests}
                    colorClass="text-brand-primary bg-brand-primary"
                />
                 <StatDisplay 
                    icon={<TargetIcon className="w-6 h-6"/>}
                    label="Avg. Accuracy"
                    value={`${stats.accuracy}%`}
                    colorClass="text-brand-secondary bg-brand-secondary"
                />
                 <StatDisplay 
                    icon={<ChartBarIcon className="w-6 h-6"/>}
                    label="Avg. Score"
                    value={stats.averageScore}
                    colorClass="text-brand-accent-amber bg-brand-accent-amber"
                />
            </div>
        </div>
    );
};